import { find, get, includes, orderBy, head } from 'lodash';

export const isLoading = (state, teamId, seasonId) =>
  includes(get(state, 'teams.statistics.currentlyLoading'), [teamId, seasonId].join('-'));

export const hasLoaded = (state, teamId, seasonId) =>
  includes(get(state, 'teams.statistics.hasLoaded'), [teamId, seasonId].join('-'));

export const getLoadingError = (state, teamId) =>
  find(get(state, 'teams.statistics.loadingError'), { teamId });

export const getSeasons = (state, teamId) => get(state, `teams.statistics.seasons[${teamId}]`, []);

export const getDefaultSeasonId = (state, teamId) => {
  const season = head(getSeasons(state, teamId));
  return season && season.id;
};

export const getSeasonsOrderedByDate = (state, teamId) =>
  orderBy(get(state, `teams.statistics.seasons[${teamId}]`, []), ['end'], ['desc']);

export const getSeason = (state, teamId, seasonId) =>
  find(getSeasons(state, teamId), ['id', seasonId]);

export const getFixtureStatistics = (state, teamId, seasonId) =>
  get(state, `teams.statistics.statistics[${[teamId, seasonId].join('-')}]`, {});

export const getPointStatistics = (state, teamId, seasonId) =>
  get(state, `teams.statistics.pointStatistics[${[teamId, seasonId].join('-')}]`, {});

export const getPlayerStatistics = (state, teamId, seasonId) =>
  get(state, `teams.statistics.playerStatistics[${[teamId, seasonId].join('-')}]`, []);

export const getPlayerStatisticsTables = (state, teamId, seasonId) =>
  get(state, `teams.statistics.playerStatsTables[${[teamId, seasonId].join('-')}]`, []);
